import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    input: {
        textAlign: 'center',
        '&:before': {
            borderColor: 'red',
        },
    },
    field: {
        flex: '1 1 24%',
        alignSelf: 'baseline',
        boxSizing: 'border-box',
        textAlign: 'center',
    },
    row: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        boxSizing: 'border-box',
        padding: '0 4px',
    },
    tableHeader: {
        padding: `${theme.spacing(2)}px 0 ${theme.spacing(1)}px`,
        flex: '1 1 25%',
        alignSelf: 'baseline',
        boxSizing: 'border-box',
        textAlign: 'center',
        lineHeight: '22px',
        color: theme.palette.primary.main,
    },
    wrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        flex: '1 1 45%',
        ['@media (max-width:440px)']: {
            flexBasis: '100%',
        },
    },
}));
